import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Markdown from '../Markdown'
import { bodyText, colours } from '../player/playerStyles'
import useBlockState from './useBlockState'

// Complete once the video has played to the end, or the transcript has been
// opened (so nobody is forced to watch to continue).
const VideoBlock = ({ block, content, initialState, onStateChange }) => {
  const [state, update] = useBlockState(initialState ?? {}, onStateChange)
  const media = content?.media ?? {}
  const markWatched = () => {
    if (!state.watched) update({ watched: true })
  }

  return (
    <Box sx={{ maxWidth: '74ch' }}>
      <Box
        component="video"
        controls
        preload="metadata"
        playsInline
        onEnded={markWatched}
        aria-label={block.title}
        sx={{ display: 'block', width: '100%', borderRadius: 1, bgcolor: '#000' }}
      >
        <source src={media[block.src] ?? block.src} />
        <track kind="captions" srcLang="en" label="English" src={media[block.captions] ?? block.captions} default />
      </Box>
      <Accordion
        disableGutters
        variant="outlined"
        onChange={(event, expanded) => expanded && markWatched()}
        sx={{ mt: 2, borderColor: colours.border }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 48 }}>
          <Typography component="span" sx={{ fontSize: '1.0625rem', fontWeight: 700 }}>
            Read the transcript
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Markdown sx={bodyText}>{block.transcript}</Markdown>
        </AccordionDetails>
      </Accordion>
      <Typography aria-live="polite" sx={{ fontSize: '1rem', color: colours.muted, mt: 1, minHeight: '1.6em' }}>
        {state.watched ? 'Video marked as watched.' : ''}
      </Typography>
    </Box>
  )
}

export default VideoBlock
